import { Link } from 'gatsby';
import React from 'react';
import { ArrowRight } from 'lucide-react';
import styled from '../../styled';
import { COLORS } from '../../themes/color';
import { Headline } from '../Headline';
import { Kicker } from '../Kicker';
import { mobileHeroLeadText } from '../MarketingTypography';
import { Reveal } from '../motion';

const SectionWrapper = styled('section')`
  padding: 100px 24px;
  max-width: 900px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 960px) {
    padding: 80px 24px;
  }
`;

const SectionDescription = styled('p')`
  font-size: 18px;
  line-height: 1.6;
  color: #4f4f4f;
  margin: 16px auto 40px;
  max-width: 720px;
  ${mobileHeroLeadText}
`;

const ButtonContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
`;

const PrimaryLink = styled(Link)`
  background-color: #0e1c2b;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  border-radius: 100px;
  padding: 14px 32px;
  text-decoration: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1f3348;
  }
`;

const SecondaryLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${COLORS.PRIMARY};
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;

  &:hover {
    opacity: 0.8;
  }
`;

export const DemandCalloutSection = () => {
  return (
    <SectionWrapper id="demand">
      <Reveal>
        <Kicker>New</Kicker>
        <Headline component="h2">Announcing the AI Influence Exchange</Headline>
        <SectionDescription>
          Publishers sell the AI visibility their content already earns. Brands
          earn their place in AI recommendations.
        </SectionDescription>
        <ButtonContainer>
          <PrimaryLink to="/ai-exchange/">Explore the Exchange</PrimaryLink>
          <SecondaryLink to="/ai-exchange/#discovery-call">
            Book a discovery call <ArrowRight size={18} />
          </SecondaryLink>
        </ButtonContainer>
      </Reveal>
    </SectionWrapper>
  );
};
